import { Inject, Injectable } from '@angular/core';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class MessageService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "message");
    }
}
